import { useContext } from "react";
import { Row, Col, AccordionContext, useAccordionToggle } from "react-bootstrap";
import PropTypes from "prop-types";
import { ReactComponent as SortIcon } from "assets/images/icons/SortDown.svg";
import { formatNumber } from "helpers/commonHelpers";

function CustomToggle({ eventKey, callback, item }) {
  const activeEventKey = useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(eventKey, () => callback && callback(eventKey));
  const isCurrentEventKey = activeEventKey === eventKey;

  const totalQuotedValue = item.items.reduce((acc, item) => {
    if (!item.quotedCurrency) return acc;
    if (acc[item.quotedCurrency]) acc[item.quotedCurrency] += parseFloat(item.quotedValue);
    else acc[item.quotedCurrency] = parseFloat(item.quotedValue);
    return acc;
  }, {});

  const totalInvoicedValue = item.items.reduce((acc, item) => {
    if (!item.invoicedCurrency) return acc;
    if (acc[item.invoicedCurrency]) acc[item.invoicedCurrency] += parseFloat(item.invoicedValue);
    else acc[item.invoicedCurrency] = parseFloat(item.invoicedValue);
    return acc;
  }, {});

  const formatValue = (value, currency) => {
    if (value === 0) return "-";
    return `${formatNumber(value)} ${currency}`;
  };

  return (
    <Row className="mt-3 mb-3 cursor-pointer" onClick={decoratedOnClick}>
      <Col className="mb-0 font-weight-bold">
        <div className="d-flex align-items-center">
          {item.group_name}{" "}
          <SortIcon className="ml-1" fill="#000" width={8} height={7} transform={`rotate(${isCurrentEventKey ? 180 : 0})`} />
        </div>
      </Col>
      <Col className="font-weight-bold">
        {Object.entries(totalQuotedValue).length
          ? Object.entries(totalQuotedValue).map(([key, value], i) =>
              i === Object.entries(totalQuotedValue).length - 1 ? formatValue(value, key) : `${formatValue(value, key)} / `,
            )
          : "-"}
      </Col>
      <Col className="font-weight-bold">
        {Object.entries(totalInvoicedValue).length
          ? Object.entries(totalInvoicedValue).map(([key, value], i) =>
              i === Object.entries(totalInvoicedValue).length - 1
                ? formatValue(value, key)
                : `${formatValue(value, key)} / `,
            )
          : "-"}
      </Col>
    </Row>
  );
}

CustomToggle.propTypes = {
  eventKey: PropTypes.string.isRequired,
  callback: PropTypes.func,
  item: PropTypes.instanceOf(Object).isRequired,
};

CustomToggle.defaultProps = {
  callback: undefined,
};

export default CustomToggle;
